import { useState, useRef, useEffect, cloneElement } from 'react';
import { is, css, und } from './Utils';

export const Animate = ({ duration = 300, show, children, animation }) => {
	const [state, setState] = useState(show);
	const ref = useRef(null);

	useEffect(() => {
		const target = ref.current;
		if (!target) return;
		let cleanup, cleanupSlide;
		let { enter = {}, exit = {} } = animation;
		const precursor = 60;
		const isSlideIn = enter === 'slideIn';
		const isSlideOut = exit === 'slideOut';
		enter = isSlideIn ? { height: `${target.scrollHeight}px` } : enter;
		exit = isSlideOut ? { height: 0 } : exit;

		if (show) {
			cleanup = setTimeout(() => {
				css(target, enter);
				!state && setState(true);
				if (isSlideIn) {
					cleanupSlide = setTimeout(() => {
						css(target, { height: null });
					}, duration - precursor);
				}
			}, precursor);
		}

		if (!show && state) {
			cleanupSlide = setTimeout(() => {
				css(target, exit);
			}, precursor);
			cleanup = setTimeout(() => {
				setState(false);
			}, duration + precursor);
			if (isSlideOut) {
				css(target, enter);
			}
		}

		return () => {
			cleanup && clearTimeout(cleanup);
			cleanupSlide && clearTimeout(cleanupSlide);
		};
	}, [show, state, duration, animation, ref]);

	return (
		(show || state) &&
		cloneElement(children, {
			reference: (!is.str(children.type) && ref) || und,
			ref: is.str(children.type) ? ref : und,
			style: {
				...children.props.style,
				...(is.str(animation.exit)
					? { height: 0, overflow: 'hidden' }
					: animation.exit),
			},
		})
	);
};
